import { render } from "./MainReportProfits.vue?vue&type=template&id=3d86fe96&scoped=true"
import script from "./MainReportProfits.vue?vue&type=script&lang=js"
export * from "./MainReportProfits.vue?vue&type=script&lang=js"

import "./MainReportProfits.vue?vue&type=style&index=0&id=3d86fe96&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d86fe96"]])

export default __exports__